import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { showConfirmationDialog } from '@actions/confirmation-actions';

import DetailsContent from '@components/details/details-content';

import { Tab, Tabs } from '@shared/tabs';

import DemoGeneral from './demo-general';
import TaskTypeLayout from './task-type-layout';
import TaskTypeDrawer from './task-type-drawer';
import TaskTypePreview from './task-type-preview';
import TaskTypeStatus from './task-type-status';

const Fields = TaskTypeLayout(TaskTypePreview, TaskTypeDrawer);

const TaskType = () => {
  const [tab, setTab] = useState('fields');
  const { global: { demo_task_type_layout } } = useSelector(state => state.config);
  const dispatch = useDispatch();

  const showModal = useCallback(label => {
    dispatch(showConfirmationDialog(
      label,
      'Please sign up to an enterprise model to utilize this feature'
    ));
  }, [dispatch]);

  useEffect(() => {
    if (tab === 'Workflow' || tab === 'Fees' || tab === 'Activity Log') {
      showModal(tab);
    }
  }, [showModal, tab]);

  // Use a different layout for the permit demo (this code might be temporal).
  if (demo_task_type_layout) {
    const tabStyle = { textTransform: 'capitalize' };
    return (
      <DetailsContent>
        <Tabs
          data-testid="admin-tasktype-tabs"
          onChange={setTab}
          tabItemWidth="100px"
          tabTemplateStyle={{ height: '100%' }}
          value={tab}
        >
          {/*
            I know the 'fields' key is for the Fields component,
            but I use it here for he General tab and I use 'builder'
            for the fields one, since this is for the demo code.
            Else I would have to make the useState above conditional,
            and that would make the code more complex when we have to
            remove this demo code.
          */}
          <Tab label="General" value="fields" style={tabStyle}>
            {tab === 'fields' && <DemoGeneral />}
          </Tab>
          <Tab label="Builder" value="Builder" style={tabStyle}>
            {tab === 'Builder' && <Fields />}
          </Tab>
          <Tab label="Workflow" value="Workflow" style={tabStyle}>
            {tab === 'Workflow' && <div />}
          </Tab>
          <Tab label="Fees" value="Fees" style={tabStyle}>
            {tab === 'Fees' && <div />}
          </Tab>
          <Tab label="Activity Log" value="Activity Log" style={tabStyle}>
            {tab === 'Activity Log' && <div />}
          </Tab>
        </Tabs>
      </DetailsContent>
    );
  }

  return (
    <DetailsContent>
      <Tabs
        data-testid="admin-tasktype-tabs"
        onChange={setTab}
        tabItemWidth="100px"
        tabTemplateStyle={{ height: '100%' }}
        value={tab}
      >
        <Tab data-testid="admin-tasktype-tab-1" label="FIELDS" value="fields">
          {tab === 'fields' && <Fields />}
        </Tab>
        <Tab data-testid="admin-tasktype-tab-2" label="STATUS" value="status">
          {tab === 'status' && <TaskTypeStatus />}
        </Tab>
      </Tabs>
    </DetailsContent>
  );
};

export default TaskType;
